import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";
import { ToastProgrammatic as Toast } from "buefy";
import { DialogProgrammatic as Dialog } from "buefy";
export interface CDFProductData {
  id?: number;
  stream: number;
  sheet_name: string;
  field_name: string;
  description: string;
  allowed_values: string;
  example_data: string;
  field_type: number;
}
const exportLargeCount = 65000;
//TODO set to 65000 before prod/tst deployment
export default class CDFProductDataService {
  private httpClient = makeHttpClient();

  getAll(
    customer_id: number,
    hasNADropdown = false,
    hideCertificateFields = false
  ) {
    let url = `${env.cdfProductUrl}customer/template/`;

    if (customer_id != null) {
      url =
        url + `?customer_id=${customer_id}` + `&na_dropdown=${hasNADropdown}`;
    } else {
      url = url + `?na_dropdown=${hasNADropdown}`;
    }

    if (hideCertificateFields) {
      url = url + `&hide_certificate_fields=${hideCertificateFields}`;
    }
    return _unwrapAxiosResponse(this.httpClient.get<CDFProductData>(url));
  }
  getCdfField(customer_id: number) {
    let url = `${env.cdfProductUrl}customer/template`;
    if (customer_id != null) {
      url = url + `?customer_id=${customer_id}`;
    }
    return _unwrapAxiosResponse(this.httpClient.get<CDFProductData>(url));
  }

  generateCDF(cdfId: any, data: any) {
    return _unwrapAxiosResponse(
      this.httpClient.post<CDFProductData>(
        env.cdfProductUrl + `${cdfId}/generate_cdf/`,
        data
      )
    );
  }

  saveAsDraft(cdfId: any, data: any) {
    return _unwrapAxiosResponse(
      this.httpClient.post<CDFProductData>(
        env.cdfProductUrl + `${cdfId}/save_as_draft/`,
        data
      )
    );
  }

  sendForApproval(cdfId: any, data: any) {
    return _unwrapAxiosResponse(
      this.httpClient.post<CDFProductData>(
        env.cdfProductUrl + `${cdfId}/send_for_approval/`,
        data
      )
    );
  }

  approve(cdfId: any) {
    return _unwrapAxiosResponse(
      this.httpClient.post<CDFProductData>(
        env.cdfProductUrl + `${cdfId}/confirm/`
      )
    );
  }

  reject(cdfId: any, comment: any) {
    const data = {
      comment: comment
    };
    return _unwrapAxiosResponse(
      this.httpClient.post<CDFProductData>(
        env.cdfProductUrl + `${cdfId}/reject/`,
        data
      )
    );
  }

  cdfTemplateExport(customer_id: number) {
    let url = `/cdf/cdftemplate/`;

    if (customer_id != null) {
      url = url + `?customer_id=${customer_id}`;
    }
    this.httpClient
      .get(url, { responseType: "blob" })
      .then(({ data }) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "CDF Template.xlsx"); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(e => {
        Dialog.alert({
          title: "Export not possible",
          message:
            "There are no approved versions yet. Please contact your Customer Account Manager for further information ",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      });
  }

  exportProducts(
    customer: any,
    ImportType: any,
    stream: any,
    ids: number[],
    count: any
  ) {
    const params = new URLSearchParams();
    params.append("tenant", customer);
    params.append("import_type", ImportType);
    params.append("stream", stream);
    params.append("count", count);

    let fileName = `Export_products.xlsx`;
    if (stream.includes("PRODUCT")) {
      fileName = `Export_products.xlsx`;
    } else if (stream.includes("BATT")) {
      fileName = `Export_products_batt.xlsx`;
    } else if (stream.includes("WEEE")) {
      fileName = `Export_products_weee.xlsx`;
    } else if (stream.includes("PACK")) {
      fileName = `Export_products_pack.xlsx`;
    } else if (stream.includes("BUNDLE")) {
      fileName = `Export_products_bundle.xlsx`;
    }

    if (ids.length == 0) {
      throw new Error("Please select at least one record.");
    } else {
      ids.map(id => {
        params.append("records", "" + id);
      });
      const url = `${env.dataManagementTempUrl}export/pd/?${params.toString()}`;

      this.httpClient
        .get(url, { responseType: "blob" })
        .then(({ data }) => {
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          if (count >= exportLargeCount) {
            return 1;
          } else {
            link.href = downloadUrl;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
        })
        .catch(err => {
          Dialog.alert({
            title: "Export not possible",
            message: "There is some issue with exporting the file.",
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true
          });
          return err;
        });
    }
  }

  exportAllProducts(
    customer: any,
    ImportType: any,
    stream: any,
    query: any,
    count: any
  ) {
    const params = new URLSearchParams();
    params.append("tenant", customer);
    params.append("import_type", ImportType);
    params.append("stream", stream);
    params.append("count", count);

    let fileName = `Export_all_products.xlsx`;
    if (stream.includes("PRODUCT")) {
      fileName = `Export_all_products.xlsx`;
    } else if (stream.includes("BATT")) {
      fileName = `Export_all_products_batt.xlsx`;
    } else if (stream.includes("WEEE")) {
      fileName = `Export_all_products_weee.xlsx`;
    } else if (stream.includes("PACK")) {
      fileName = `Export_all_products_pack.xlsx`;
    } else if (stream.includes("BUNDLE")) {
      fileName = `Export_all_products_bundle.xlsx`;
    }
    const url =
      `${env.dataManagementTempUrl}export/pd/all/?${params.toString()}` + query;
    return _unwrapAxiosResponse(
      this.httpClient.get(url, { responseType: "blob" }).then(
        ({ data }) => {
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));

          const link = document.createElement("a");

          if (count >= exportLargeCount) {
            return 1;
          } else {
            link.href = downloadUrl;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            return data;
          }
        },
        err => {
          Dialog.alert({
            title: "Export not possible",
            message: "You cannot export data more than 65000 at once",
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true
          });
          return err;
        }
      )
    );
  }
  exportCompleteProducts(customer: any, ImportType: any) {
    const params = new URLSearchParams();
    const headers = {
      tenant: customer
    };
    params.append("import_type", ImportType);
    const url = `${
      env.dataManagementTempUrl
    }export/pd/complete/?${params.toString()}`;
    return _unwrapAxiosResponse(
      this.httpClient
        .get(url, { responseType: "blob", headers })
        .then(response => {
          const { data } = response;
          const contentType = response.headers["content-type"];
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");

          if (contentType == "application/json") {
            const successToast = Toast.open({
              message: "Exported file will be sent to your email address",
              type: "is-success"
            });
            return 1;
          } else {
            link.href = downloadUrl;
            link.setAttribute("download", "export_all_products.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            return data;
          }
        })
    );
  }

  exportAllTransactions(customer: any, importType: any, query: any) {
    const params = new URLSearchParams();
    params.append("tenant", customer);
    params.append("import_type", importType);

    const url =
      `${env.dataManagementTempUrl}export/td/all/?${params.toString()}` + query;
    return _unwrapAxiosResponse(
      this.httpClient.get(url, { responseType: "blob" }).then(
        ({ data }) => {
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));

          const link = document.createElement("a");

          link.href = downloadUrl;

          link.setAttribute("download", "export_all_transactions.xlsx");

          document.body.appendChild(link);

          link.click();

          link.remove();
          return data;
        },
        err => {
          Dialog.alert({
            title: "Export not possible",
            message: "You cannot export data more than 65000 at once",
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true
          });
          return err;
        }
      )
    );
  }

  saveBulkComment(
    customer: any,
    ids: number[],
    query: any,
    allRecords: boolean,
    data: any,
    stream: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    const params = new URLSearchParams();
    params.append("tenant", customer);
    params.append("comment", data);
    params.append("stream", stream);
    params.append("all_records", allRecords.toString());
    if (ids.length > 0 && !allRecords) {
      ids.map(id => {
        params.append("records", "" + id);
      });
    }
    const url =
      `${env.dataManagementTempUrl}product/bulk/comment/?${params.toString()}` +
      query;
    return _unwrapAxiosResponse(
      this.httpClient.get<CDFProductData>(url, headers)
    );
  }

  deactivateBulkProducts(
    customer: any,
    ids: number[],
    query: any,
    allRecords: boolean,
    stream: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "application/json",
        tenant: customer
      }
    };
    const params = new URLSearchParams();
    params.append("all_records", allRecords.toString());
    if (ids.length > 0 && !allRecords) {
      ids.map(id => {
        params.append("records", "" + id);
      });
    }
    const url =
      `${
        env.dataManagementTempUrl
      }product/bulk/deactivate/?${params.toString()}` + query;
    return _unwrapAxiosResponse(
      this.httpClient.post<CDFProductData>(url, {}, headers)
    );
  }

  getProductDetailWithStreams(productId: number, customer: string) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    const url = `${env.dataManagementTempUrl}product/detail-with-streams/${productId}/`;
    return _unwrapAxiosResponse(this.httpClient.get<any>(url, headers));
  }
}
